import { useEffect, useState } from "react";
import ObservationTextDetail from "./observationTextDetails/ObservationTextDetail";
import "./textViewer.css";
import OrganizationTextDetails from "./organizationTextDetails/OrganizationTextDetails";
import DiagnosticReportTextDetails from "./diagnosticReportTextDetails/DiagnosticReportTextDetails";
import CoverageTextDetails from "./coverageTextDetails/CoverageTextDetails";
import PatientTextDetails from "./patientTextDetails/PatientTextDetails";
import MedicationStatementTextDetails from "./medicationStatementTextDetails/MedicationStatementTextDetails";
import ConditionTextDetails from "./conditionTextDetails/ConditionTextDetails";
import ProcedureTextDetails from "./procedureTextDetails/ProcedureTextDetails";
import PractitionerTextDetails from "./practitionerTextDetails/PractitionerTextDetails";
import DischargeSummaryTextDetails from "./dischargeSummaryTextDetails/DischargeSummaryTextDetails";

const TextViewer = ({ data }) => {
  console.log("text", data);
  return (
    <div className="text-container">
      {data && data.resource.resourceType === "Observation" && (
        <ObservationTextDetail observationDetailsData={data} />
      )}
      {data && data.resource.resourceType === "Organization" && (
        <OrganizationTextDetails organizationDetailsData={data} />
      )}
      {data && data.resource.resourceType === "DiagnosticReport" && (
        <DiagnosticReportTextDetails diagnosticDetailsData={data} />
      )}
      {data && data.resource.resourceType === "Coverage" && (
        <CoverageTextDetails coverageDetailsData={data} />
      )}
      {data && data.resource.resourceType === "Patient" && (
        <PatientTextDetails patientDetailsData={data} />
      )}
      {data && data.resource.resourceType === "MedicationStatement" && (
        <MedicationStatementTextDetails medicationDetailData={data} />
      )}
      {data && data.resource.resourceType === "Condition" && (
        <ConditionTextDetails conditionDetailData={data} />
      )}
      {data && data.resource.resourceType === "Procedure" && (
        <ProcedureTextDetails procedureDetailData={data} />
      )}
      {data && data.resource.resourceType === "Practitioner" && (
        <PractitionerTextDetails practitionerDetailData={data} />
      )}
      {data && data.resource.resourceType === "Composition" && (
        <DischargeSummaryTextDetails dischargeDetailData={data} />
      )}
    </div>
  );
};

export default TextViewer;
